import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormSection from '../formSectionNew';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Images from 'assets/images/imageData';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import { handleValidateObj } from 'constants/objValues/objvalues';
import Regex from 'services/utils/regex/Regex';

const GSTDetails = ({ handleValue, documentUploadUrl, documentUrlData, prefilledData }) => {
  const gstInputs = {
    gstRegis: '',
    gstNumber: '',
    gstFile: '',
    nonGstFile: '',
    gstRegisPrefilled: { id: null, name: '' },
    gstTypePrefilled: { id: null, name: '' },
  };

  const [isRegisterd, setIsRegisterd] = useState('');
  const [gstData, setGstData] = useState(gstInputs);

  const handleChange = (val) => {
    setIsRegisterd(val?.value?.toLowerCase());
    setGstData({ ...gstData, gstRegis: val.id,gstType:'', gstFile: ''});
  };
  const handleTypeChange = (val) => {
    
  };

  const handleGstData = () => {
    const gstObj = {
      gstRegis: gstData.gstRegis,
    };
    if (isRegisterd === 'yes') {
      // gstObj.gstNumber = gstData.gstNumber;
      gstObj.gstType = 1;
    }else if(isRegisterd === 'no'){
      gstObj.gstType = 2;
    }
    const isNotEmpty = handleValidateObj(gstObj);
    if (isNotEmpty !== false) {
      handleValue({
        ...gstData,
        gstNumber : gstData.gstNumber,
        gstFile: gstData.gstFile,
        nonGstFile: gstData.nonGstFile,
      });
    } else {
      handleValue(null);
    }
  };

  useEffect(() => {
    handleGstData();
  }, [gstData]);

  useEffect(() => {
    if (
      prefilledData?.gst_details !== undefined &&
      prefilledData?.gst_details !== null
    ) {
      const {
        gst_registered,
        gst_number,
        gstType,
        gst_document,
        upload_non_gst_disclosure_form
      } = prefilledData?.gst_details;

      const {
        gst_details
      } = prefilledData?.commercial;
      
      setIsRegisterd(gst_registered === '1' ? 'yes' : 'no');
      let gstId = (gst_registered === '1' ? 1 : 2);
      let gstVal = (gst_registered === '1' ? 'Yes' : 'No');
      let gstTypeVal = (gstType === '1' ? 'SEZ' : 'Other Than SEZ');
      let gstDetails = JSON.parse(gst_details);
      setTimeout(() => {
        setGstData({ 
          ...gstData,
          gstRegis: gst_registered,
          gstNumber: (gst_number !== 'null' && gst_number !== null && gst_number !== undefined) ? gst_number : '',
          gstFile: (gst_document!="undefined"&&gst_document!="null")?gst_document:'',
          gstType:gstType,
          gstTypeVal:gstTypeVal,
          nonGstFile: (upload_non_gst_disclosure_form!="undefined"&&upload_non_gst_disclosure_form!="null")?upload_non_gst_disclosure_form:'',
          gstRegisPrefilled: { id: gstId, name: gstVal},
        });
      }, 100);
    }
  }, [prefilledData]);
  //console.log('gst ' + typeof(gstData.gstNumber));

  return (
    <FormSection title={localization.gstDetails}>
      <ConstantInput
        label={localization.gstNumber}
        // required
        // isStarRequired={true}
        type="text"
        regex={Regex.alphaNum.test(gstData.gstNumber)}
        maxLength={15}
        errorMsg={
          gstData.gstNumber === ''
            ? ''
            : localization.alphaNumericError
        }
        // localization.requiredgstNumber
        handleChange={(val) => setGstData({ ...gstData, gstNumber: val })}
        value={gstData.gstNumber}
      />
      <DropDownInput
        data={[
          { name: 'Yes', id: 1 },
          { name: 'No', id: 2 },
        ]}
        label={localization.gstRegis}
        required
        isStarRequired={true}
        errorMsg={localization.requiredgstDetails}
        getIdValue={(val) => handleChange(val)}
        value={gstData.gstRegisPrefilled.name}
      />
      {isRegisterd === 'yes' && (
        <Fragment>
          {/*<ConstantInput
            label={localization.gstNumber}
            required
            isStarRequired={true}
            type="text"
            regex={Regex.alphaNum.test(gstData.gstNumber)}
            maxLength={15}
            errorMsg={
              gstData.gstNumber === ''
                ? localization.requiredgstNumber
                : localization.alphaNumericError
            }
            handleChange={(val) => setGstData({ ...gstData, gstNumber: val })}
            value={gstData.gstNumber}
          />*/}
          {/* <DropDownInput
        data={[
          { name: 'SEZ', id: 1 },
          { name: 'Other Than SEZ', id: 2 },
        ]}
        label={localization.GSTType}
        required
        isStarRequired={true}
        errorMsg={localization.requiredgstDetails}
        getIdValue={(val) => handleChange(val)}
        value={gstData.gstTypePrefilled.name}
      /> */}
      {/*<DropDownInput
                
                label={localization.GSTType}
                data={[
                  { name: 'SEZ', id: 3 },
                  { name: 'Other Than SEZ', id: 2 },
                ]}
                required
                errorMsg={localization.requiredgstDetails}
                getIdValue={(val) =>{
                  setGstData({
                    ...gstData,
                    gstType: val.id,
                  });
                }
                }
                // handleChange={(val) => setGstData({ ...gstData, gstType: val.id, })}
            value={gstData.gstTypeVal}
                
                isStarRequired={true}
            />*/}
          <div className="w-100">
            <FileUpload
              id="docs"
              accept=".pdf,.png,.jpg"
              documentUploadUrl={documentUploadUrl}
              documentUrlData={documentUrlData}
              onChange={(val) => {
                setGstData({ ...gstData, gstFile: val });
              }}
              required
              prefilledFilename={gstData.gstFile}
            >
              <span className="btn btn-transparent">
                {localization.uploadDocs}
              </span>
            </FileUpload>
            &nbsp;
            <label
              className={`error ${gstData.gstFile === '' ? 'error-block' : ''}`}
            >
              {localization.GSTDocument}
            </label>
          </div>
        </Fragment>
      )}
      {isRegisterd === 'no' && (
        <div className="w-100">
          <FileUpload
            id="uploadNonGST"
            accept=".pdf,.png,.jpg"
            documentUploadUrl={documentUploadUrl}
            documentUrlData={documentUrlData}
            onChange={(val) => setGstData({ ...gstData, nonGstFile: val })}
            prefilledFilename={gstData.nonGstFile}
          >
            <span className="btn btn-transparent">
              {localization.uploadDocs}
            </span>
          </FileUpload>
          &nbsp;
          <label
            className={`error ${gstData.nonGstFile === '' ? 'error-block' : ''}`}
          >
            {localization.GSTDocument}
          </label>
        </div>
      )}
      {isRegisterd === 'yes' && (
        <div className="w-100">
          <label className="label info-label">
            <img src={Images?.infoIcon} alt="" />
            {localization.GSTDocument}
          </label>
        </div>
      )}
    </FormSection>
  );
};

GSTDetails.propTypes = {
  handleValue: PropTypes.func,
};

export default GSTDetails;
